var _rect, _rect2, _ellipse, _ellipse2, _ellipse3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRateFace2On(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.3,
    y: 0.8,
    width: 30.4,
    height: 30.4,
    rx: 15.2,
    fill: "#FFD8E9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.3,
    y: 0.8,
    width: 30.4,
    height: 30.4,
    rx: 15.2,
    stroke: "#FF77B1",
    strokeWidth: 1.6
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.6613,
    cy: 21.3328,
    rx: 4.8,
    ry: 5.2,
    fill: "#FF3D8F"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.1541,
    cy: 12.1619,
    rx: 2.44122,
    ry: 2.56038,
    fill: "#FF3D8F"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.1697,
    cy: 12.1619,
    rx: 2.44122,
    ry: 2.56038,
    fill: "#FF3D8F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRateFace2On);
export default __webpack_public_path__ + "static/media/icon-rate-face-2-on.23b3b92835bd06e7ad73f10089b0a5cc.svg";
export { ForwardRef as ReactComponent };